import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { useEnvironment } from "../../customHooks/useEnvironment";
import { useNavs } from "../../customHooks/useNavs";
import { useGetUserProfileQuery } from "../../redux/features/auth/auth.api";
import { Icon } from "../icons/icon";

export const BottomNav = ({ className = "" }: { className?: string }) => {
  const { navs } = useNavs();

  const { environment } = useEnvironment();

  useGetUserProfileQuery(undefined, {});

  return (
    <>
      <div
        className={classNames(
          `
          bg-white w-full p-2.5 rounded-t-2xl
          transition-all duration-500
          shadow-[0px_0px_14px_0px_rgba(0,0,0,0.08)] z-[998]
          `,
          {
            "pb-9": environment !== "mobile",
            "pb-14": environment === "mobile",
          },
          className
        )}
      >
        <div className="w-full p-1 bg-light-green-bg rounded-full flex flex-row gap-2 items-center">
          {navs.map(
            (
              { title, mobileActiveIcon, mobileIcon, to, hasCount, count },
              idx
            ) => {
              const key = `nav-item-${idx}`;

              return (
                <NavLink
                  key={key}
                  to={to}
                  className={({ isActive }) => {
                    const activeClassName = isActive
                      ? "text-pry-dark-green-400 bg-white shadow-md"
                      : "text-pry-dark-green-400/50 bg-[#F2F6F5] ";

                    return `
                    ${activeClassName}
                    flex flex-1 flex-col items-center justify-center
                    rounded-full p-1 relative text-xs
                    font-medium transition-all
                    `;
                  }}
                >
                  {({ isActive }) => {
                    return (
                      <>
                        <div className="relative">
                          <Icon
                            svg={isActive ? mobileActiveIcon : mobileIcon}
                            width={24}
                            height={24}
                            className="transition-all duration-[700ms]"
                          />

                          {hasCount && (count ?? 0) > 0 ? (
                            <p
                              className={classNames(
                                `
                                p-1 rounded-full text-[10px] absolute top-0 left-3 
                                min-w-[16px] h-[16px] flex items-center justify-center font-semibold
                                bg-info-purple text-white
                                `
                              )}
                            >
                              {(count ?? 0) > 10 ? "10+" : count}
                            </p>
                          ) : undefined}
                        </div>

                        <p className="flex-1 absolute top-[calc(100%+14px)]">
                          {title}
                        </p>
                      </>
                    );
                  }}
                </NavLink>
              );
            }
          )}
        </div>
      </div>
    </>
  );
};
